import React, { useState } from "react";
import "../index.css";

const PreguntasFrecuentes = () => {
  const [expandedQuestions, setExpandedQuestions] = useState({});

  const toggleQuestion = (questionId) => {
    setExpandedQuestions((prev) => ({
      ...prev,
      [questionId]: !prev[questionId],
    }));
  };

  const FAQCard = ({ question, answer, videoUrl, id }) => {
    const isExpanded = expandedQuestions[id];

    return (
      <div className="w-full bg-white rounded-lg border-gray-300 border-2 hover:border-secondary transition duration-300 ease-in-out p-6">
        <div className="flex flex-col gap-4">
          {/* Pregunta y botón toggle */}
          <div className="flex items-start justify-between gap-4">
            <button
              className="text-left text-lg font-main font-medium flex-1"
              onClick={() => toggleQuestion(id)}
            >
              {question}
            </button>
            <button
              className="text-3xl font-bold text-gray-600 hover:text-secondary transition-colors flex-shrink-0 w-8 h-8 flex items-center justify-center"
              onClick={() => toggleQuestion(id)}
            >
              {isExpanded ? "−" : "+"}
            </button>
          </div>

          {/* Contenido expandible */}
          <div
            className={`overflow-hidden transition-all duration-500 ease-in-out ${
              isExpanded ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <div className="flex flex-col gap-4 pt-2">
              <p className="text-gray-700 font-main font-medium text-lg text-justify">
                {answer}
              </p>
              {videoUrl && (
                <div className="w-full">
                  <iframe
                    width="100%"
                    height="315"
                    src={videoUrl}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const faqs = [
    {
      id: "pregunta1",
      question: "Perdí mi mascota: ¿cómo me ayuda la búsqueda inteligente?",
      answer:
        "Busca a tu amigo de forma inteligente siguiendo el flujo y agregando las características de la mascota para que encuentre otras con esos mismos rasgos.",
    },
    {
      id: "pregunta2",
      question: "Encontré una mascota: ¿cómo uso la búsqueda inteligente?",
      answer:
        "De la misma manera, primero filtra las mascotas con las características para saber si ese amigo ya esta subido en la página.",
    },
    {
      id: "pregunta3",
      question: "¿Cómo publico a mi mascota para adopción?",
      answer:
        "Ingresa a la sección para poner en adopción a tu mascota, llena los campos necesarios y publica el aviso para encontrarle un nuevo hogar.",
    },
    {
      id: "pregunta4",
      question: "¿Como adopto a un amigo?",
      answer:
        "Ingresá en la sección de adopciones, buscá entre los avisos disponibles y hacé click en la foto de la mascota que te interese para conocerla con más detalle y contactar con la persona responsable.",
    },
    {
      id: "pregunta5",
      question: "¿Dónde se publican los avisos de las mascotas?",
      answer:
        "Todas las publicaciones aparecen en nuestra web y en el sistema de búsqueda inteligente.Además, estas publicaciones se difunden automáticamente en nuestras redes sociales para aumentar la visibilidad y las chances de reencuentro.",
    },
    {
      id: "pregunta6",
      question: "¿Tengo que pagar?",
      answer:
        "No, BuscaTuAmigo es totalmente gratuito ninguna de sus funciones tiene costo ni cargos ocultos. Si querés apoyar el proyecto, podés hacerlo con una donación voluntaria en la sección de Donaciones.",
    },
  ];

  return (
    <div className="relative h-full w-full flex flex-col items-center justify-start bg-orange-50">
      <h2 className="absolute text-center md:text-8xl z-20 top-36 text-6xl font-bold font-main text-shadow-4xl text-white">
        Preguntas Frecuentes
      </h2>
      <div
        className="relative w-full h-[365px] bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('FAQ_image.jpg')`,
          backgroundPosition: "center 58%",
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="absolute inset-0 opacity-35 Gradient"></div>
        <div className="absolute left-0 bottom-0 w-full pointer-events-none">
          <svg
            viewBox="0 0 1440 120"
            className="w-full h-14"
            preserveAspectRatio="none"
          >
            <path
              d="M0,60 
                 C360,140 1080,-120 1440,60 
                 L1440,120 L0,120 Z"
              fill="#FDF6ED"
            />
          </svg>
        </div>
      </div>

      <div className="relative flex flex-col w-full justify-center items-center px-[5dvh] pt-12">
        <div className="flex max-w-[1000px] flex-col gap-2">
          {faqs.map((faq) => (
            <div key={faq.id} id={faq.id}>
              <FAQCard {...faq} />
            </div>
          ))}
        </div>
        <div className="flex flex-col items-center justify-center gap-4 py-24">
          <h3 className="font-main text-center font-bold text-3xl">
            ¿Tenes alguna otra pregunta?
          </h3>
          <p className="text-gray-600 font-main text-center font-medium text-md">
            No dudes en contactarnos a través de cualquiera de nuestras redes.
            ¡Estamos aquí para ayudarte!
          </p>
        </div>
        {/* <h4 className="font-main text-4xl mb-8">Contáctanos</h4>
        <section className="flex flex-row justify-between font-main mb-8">
          <article className="mr-8">
            <img
              src="./contactus.jpg"
              alt="Contact us"
              width={"550px"}
              className="rounded-lg"
            />
          </article>
          <form action="post" className="flex flex-col w-full">
            <input
              type="text"
              placeholder="Nombre"
              className="rounded-lg py-5 px-5 my-1 mx-2"
            />
            <input
              type="text"
              placeholder="Email"
              className="rounded-lg py-5 px-5 my-1 mx-2"
            />
            <textarea
              type="text"
              name="descripcion"
              // value={formData.descripcion}
              // onChange={handleInputChange}
              required
              placeholder="Mensaje"
              className="rounded-lg w-full h-40 shadow-md text-gray-600 pt-3 px-5 my-1 mx-2"
            />
          </form>
        </section>
        <button className="rounded-sm bg-secondary px-5 py-3 text-white font-main mb-10">
          Enviar
        </button> */}
      </div>
    </div>
  );
};

export default PreguntasFrecuentes;
